import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">视频爆料</h2>
          <p className="text-foreground-500 text-sm mt-2">最新网红圈视频瓜料，直击第一现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div key={item.id} className="group cursor-pointer">
              <div className="relative rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full aspect-[8/5] object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  width="400"
                  height="250"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs rounded whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="px-2 py-0.5 bg-background-950/70 text-background-50 text-xs rounded whitespace-nowrap">{item.duration}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 text-xl opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-play-fill"></i>
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 mb-1.5 group-hover:text-primary-500 transition-colors">{item.title}</h3>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views}</span>
                <span>{item.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}